module.exports = __webpack_public_path__ + "media/virtual_show/vShowLogoDark-46902160.png";